import React from 'react';
import Shiitake from 'shiitake';
import PropTypes from 'prop-types';
import './AspectRatioCardTitle.less';

const AspectRatioCardTitle = ({title}) => (
    <Shiitake lines={1} throttleRate={200} className="AspectRatioCardTitle" tagName="h4">
        {title}
    </Shiitake>
);

AspectRatioCardTitle.propTypes = {
    /** The text to display. Text will be truncated as necessary. */
    title: PropTypes.string.isRequired
};

export default AspectRatioCardTitle;
